module.exports = {
  none: "none",
  fixed: "fixed",
  range: "range",
};
